import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { VRBookingErrorModal } from "./component";
import {
  getVacationRentalsIsBookingValid,
  getPollVacationRentalsPriceQuoteCallState,
  getSelectedPaymentMethodId,
  getSession,
  getUserSelectedTravelerId,
  getVRErrorTitles,
  getVRHasError,
  getVRModalType,
  getAddMainGuestCallState,
  getConfirmationEmail,
} from "../../reducer";
import { IStoreState } from "../../../../reducers/types";
import {
  acknowledgePriceDifference,
  resetBookErrors,
  scheduleVacationRentalPriceQuote,
} from "../../actions/actions";
import {
  getAdultsCount,
  getChildrenCount,
  getFromDate,
  getPetsCount,
  getUntilDate,
} from "../../../search/reducer";
import { CallState } from "redmond";
import { getVacationRentalShopSelectedListing } from "../../../shop/reducer";

const mapStateToProps = (state: IStoreState) => ({
  hasError: getVRHasError(state),
  errorTitles: getVRErrorTitles(state),
  paymentMethodId: getSelectedPaymentMethodId(state),
  currentSession: getSession(state),
  selectedTravelerId: getUserSelectedTravelerId(state),
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
  selectedListing: getVacationRentalShopSelectedListing(state),
  childrenCount: getChildrenCount(state),
  adultsCount: getAdultsCount(state),
  isBookingValid: getVacationRentalsIsBookingValid(state),
  priceQuoteSuccessful:
    getPollVacationRentalsPriceQuoteCallState(state) === CallState.Success,
  modalType: getVRModalType(state),
  petsCount: getPetsCount(state),
  emailAddress: getConfirmationEmail(state),
  addMainGuestCallState: getAddMainGuestCallState(state),
});

const mapDispatchToProps = {
  scheduleVacationRentalPriceQuote,
  resetBookErrors,
  acknowledgePriceDifference,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type VRBookingErrorModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedVRBookingErrorModal = withRouter(
  connector(VRBookingErrorModal)
);
